import { apiRequest } from "../api/apiClient";
import { CarWashPackage } from "../types/carWash.types";
const ROUTE_PREFIX = "package";

const getWashPackages = async () => {
  const { data, error } = await apiRequest("get", `/${ROUTE_PREFIX}`);

  return { data, error };
};

const washPackageUpdate = async (wash: CarWashPackage) => {
  const { data, error } = await apiRequest(
    "put",
    `/${ROUTE_PREFIX}/${wash._id}`,
    wash
  );
  return { data, error };
};

const washPackageDelete = async (washID: string) => {
  const { data, error } = await apiRequest(
    "delete",
    `/${ROUTE_PREFIX}/${washID}`
  );
  return { data, error };
};

const washPackageAdd = async (wash: Partial<CarWashPackage>) => {
  const { data, error } = await apiRequest("post", `/${ROUTE_PREFIX}`, wash);
  return { data, error };
};

export {
  getWashPackages,
  washPackageUpdate,
  washPackageDelete,
  washPackageAdd,
};
